import { OnInit, Component, Output, Input, EventEmitter } from '@angular/core';
import { IInboxJob } from '../../interfaces/inbox-job';
import { IPageResult } from '../../interfaces/page-result';
import { OrderService } from '../../services';
import { UserService } from '../../services';
import { ActivatedRoute, Router } from '@angular/router';
import { JobStatus } from './job-screen.component';
import { EventService } from '../../services';
import { PostcodePipe } from '../../pipes/postcode.pipe';
import { Subscription } from 'rxjs';

@Component({
  selector: 'job-search',
  styleUrls: ['./job-search.component.css'],
  templateUrl: './job-search.component.html',
})
export class JobSearchComponent implements OnInit {
  public page: IPageResult<any> = {
    items: [],
    total: 0,
  };

  public data: string;
  public searchType: string;
  public noRun: boolean;
  public organisationTypeId: number;
  public selectedJob: IInboxJob;
  public searchDays: number;
  jobSearchEventSub: Subscription;

  public isLoaded: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private userService: UserService,
    private eventService: EventService,
    private postcodePipe: PostcodePipe,
    private orderService: OrderService,
  ) {
    this.jobSearchEventSub = this.eventService.JobSearchEvent.subscribe((input) => {
      if (input.runSearch == true) {
        this.searchJobs();
      }
    });

    this.route.queryParams.subscribe((params) => {
      this.searchType = params['searchType'];
    });

    this.searchDays = 30;
    this.searchJobs();
  }

  async ngOnInit() {
    this.userService.getCurrentUserOrg().then((org) => {
      this.organisationTypeId = org.organisationTypeId;
    });
  }

  ngOnDestroy() {
    this.jobSearchEventSub.unsubscribe();
  }

  getStatus(item) {
    if (!item) {
      return '';
    }

    if (item.status == JobStatus.Created) {
      var now = new Date();

      var heldEndDate = new Date();
      var exisingCapacityEndDate = new Date();

      if (typeof item.heldEndDate == 'string') {
        heldEndDate = new Date(item.heldEndDate);
      } else {
        heldEndDate = item.heldEndDate;
      }

      if (typeof item.exisingCapacityEndDate == 'string') {
        exisingCapacityEndDate = new Date(item.exisingCapacityEndDate);
      } else {
        exisingCapacityEndDate = item.exisingCapacityEndDate;
      }

      if (now < heldEndDate) {
        return 'Held';
      } else if (now >= heldEndDate && now < exisingCapacityEndDate) {
        return 'Existing Capacity';
      } else if (now >= exisingCapacityEndDate) {
        return 'Buy It Now';
      }
    }

    switch (item.status) {
      case JobStatus.Completed:
        return 'Completed';
      case JobStatus.Invoiced:
        return 'Invoiced';
      case JobStatus.Closed:
        return 'Closed';
      case JobStatus.Cancelled:
        return 'Cancelled';
      case JobStatus.Started:
        return 'Started';
    }

    return '-';
  }

  searchJobs() {
    this.isLoaded = false;
    this.data = this.route.snapshot.params['data'];

    if (this.searchType == 'postcode') {
      this.data = this.postcodePipe.transform(this.data);
    } else {
      this.data = this.data.replace(' ', '');
    }

    this.orderService
      .searchJobs({
        value: this.data,
        searchType: this.searchType,
      })
      .then((items) => {
        this.eventService.JobSearchEvent.emit({ searchComplete: true });

        if (
          items.length == 0 &&
          this.searchType == 'job' &&
          this.organisationTypeId == 1 &&
          this.data.startsWith('JX-')
        ) {
          const queryParams: any = {
            ['jobNumberOrVehicleReg']: this.data,
            ['excludeClashSeverities']: null,
          };

          this.router.navigate(['app/routes-inbox'], {
            queryParams: queryParams,
          });
        } else if (items.length == 1) {
          if (this.organisationTypeId == 2) {
            //for customer
            this.router.navigate(['app/jobscreen/' + items[0].id + '/' + items[0].orderId]);
          } else {
            this.router.navigate(['app/jobscreen', items[0].id]); // ?? Shouldn't jobscreen have a trailing /
          }
        } else {
          this.searchResponse(items);
        }
      });
  }

  searchResponse(items) {
    this.page.items = items;
    this.page.total = items.length;
    this.isLoaded = true;
  }

  showDetails(item) {
    if (this.organisationTypeId == 2)
      this.router.navigate(['app/jobscreen/' + item.id + '/' + item.orderId]);
    else this.router.navigate(['app/jobscreen', item.id]);
  }

  back() {
    this.router.navigate(['app/vmeinbox/']);
  }

  itemsCountPostfix(item, value, count) {
    if (value == null || value == '' || count < 2) return value;
    return value + ' (+' + (count - 1) + ')';
  }

  vehicleCountPostfix(item, value) {
    return this.itemsCountPostfix(item, value, item.vehiclesNum);
  }
}
